import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateShippingZone } from "../../api/apiShipping";
import parseError from "../../utils/parseError";

export const useUpdateShippingZone = () => {
    const queryClient = useQueryClient();

    const { mutate: updateShippingZoneMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateShippingZone(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Shipping zone updated successfully");
            queryClient.invalidateQueries(["shipping-zones"]);
            queryClient.invalidateQueries(["shipping-zone"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to update shipping zone");
        },
    });

    return { updateShippingZoneMutate, isUpdating };
};
